import React, { Fragment } from "react";
import useDonationList from "../hooks/useDonationList";
import DonationItem from "./DonationItem";
import DonationsForm from "./DonationsForm";
import "./DonationList.scss";

function DonationList({ setReadyCheckout, className }) {
  const {
    onClickEditItem,
    onClickDeleteItem,
    frequency,
    editStateItems,
    items,
    setEditStateItems,
    onClickSubmit,
    onSubmitItem,
    loadingItems,
  } = useDonationList({ setReadyCheckout });
  const countEmptyItems = items.filter(
    (v) => parseInt(v.attributes.total_price.number) === 0
  ).length;
  const hasEmptyItems = countEmptyItems > 0;
  let showEmptyHelpTipOnce = hasEmptyItems;

  return (
    <div className={`order-item-list${className ? " " + className : ""}`}>
      {items.map((item, index) => {
        const isSelected = editStateItems.some((i) => i === item.id);
        const itemPrice = parseFloat(item.attributes.total_price.number);
        const showItemSummary = !isSelected && itemPrice !== 0;
        const isLoading = loadingItems.includes(item.id);
        const showEmptyHelpTip = showEmptyHelpTipOnce && itemPrice === 0;
        if (showEmptyHelpTip) {
          showEmptyHelpTipOnce = false;
        }
        return (
          <Fragment key={item.id}>
            {(showItemSummary && (
              <>
                <div className="order-item-header__wrapper">
                  <div className="order-item-header">
                    <div className="order-item-header__title">Gift Details</div>
                    <div className="order-item-header__amount">Gift Amount</div>
                    <div className="order-item-header__delete-button-spacer"></div>
                  </div>
                </div>
                <DonationItem
                  item={item}
                  isLoading={isLoading}
                  onClickEditItem={onClickEditItem}
                  onClickDeleteItem={onClickDeleteItem}
                  frequency={frequency}
                />
              </>
            )) || (
              <DonationsForm
                index={index}
                isLoading={isLoading}
                key={item.id}
                item={items[index]}
                showEmptyHelpTip={showEmptyHelpTip}
                countItems={items.length}
                countEmptyItems={countEmptyItems}
                setEditStateItems={setEditStateItems}
                editStateItems={editStateItems}
                onClickDeleteItem={onClickDeleteItem}
                onClickSubmit={onClickSubmit}
                onSubmitItem={onSubmitItem}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}

export default DonationList;
